module.exports = __webpack_public_path__ + "static/media/ICP.989906ab.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ICP.jpeg
// module id = 326
// module chunks = 2